export const onDeleteModel = id => ({
  widget: 'models',
  type: 'onDeleteModel',
  payload: { id },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDeleteModel.js